<style>
</style>
<template>
    <div style="width: 100%;background-color: white;">
        <Breadcrumb></Breadcrumb>
        <div style="background-color: white;height: 50px;padding-top: 20px">
            <span style="margin-left: 20px;">
                推广记录
            </span>
        </div>
        <div style="background-color: white">
            <div v-for="(item,i) in list" :key="i" style="border: 1px solid #DCDFE6;margin: 0px 50px 20px 50px">
                <el-row>
                    <el-col :span="1" style="margin: 50px 30px 20px 50px">
                        <el-avatar
                                :src="item.img"></el-avatar>
                    </el-col>
                    <el-col :span="1" style="margin: 60px 30px 20px 10px">
                        <span><strong>{{item.name}}</strong></span>
                    </el-col>
                    <el-col :span="19" style="text-align: right;margin: 60px 30px 20px 0px">
                        <span>
                            {{item.date}}
                        </span>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
    import Breadcrumb from '@/components/common/Breadcrumb'
    export default {
        name:'myPromotion',
        components:{Breadcrumb},
        data: function () {
            return {
                list:[
                    {
                        img:'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
                        name:'Windir\'s',
                        date:'2020-05-20 12:00   账号注册'
                    } ,
                    {
                        img:'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
                        name:'Windir\'s',
                        date:'2020-05-20 12:00   账号注册'
                    },
                    {
                        img:'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
                        name:'Windir\'s',
                        date:'2020-05-20 12:00   账号注册'
                    } ,
                    {
                        img:'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
                        name:'Windir\'s',
                        date:'2020-05-20 12:00   账号注册'
                    },
                    {
                        img:'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
                        name:'Windir\'s',
                        date:'2020-05-20 12:00   账号注册'
                    } ,
                    {
                        img:'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
                        name:'Windir\'s',
                        date:'2020-05-20 12:00   账号注册'
                    }
                ]
            };
        },
        methods: {}
    }
</script>
